module.exports = __webpack_public_path__ + "media/images/logo2-7df10def.png";